import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  ADD_PRODUCT,
  ADD_SUB_PRODUCT,
} from "../ActionTypes/productActionTypes";

// État initial
const initialState = {
  loading: false,
  products: [],
  error: "",
};

// Reducer pour les produits
const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload,
      };

    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_PRODUCT:
      return {
        ...state,
        products: [...state.products, action.payload],
      };

    // Action pour ajouter un sous-produit à un produit spécifique
    case ADD_SUB_PRODUCT:
      return {
        ...state,
        products: state.products.map((product) =>
          product._id === action.payload.productId
            ? {
                ...product,
                subProducts: [...product.subProducts, action.payload.subProduct], // Ajouter le sous-produit
              }
            : product
        ),
      };


      
    default:
      return state;
  }
};

export default productReducer;
